import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { CanComponentDeactivate } from './can-deactivate.types';

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
  _currentRoute,
  _currentState,
  nextState) => {
  const destination = nextState?.url || '';

  // Only ask the component if it actually answers. The guard is now attached to
  // routes whose component does not implement CanComponentDeactivate — /preferences
  // is one — and calling a missing method here throws inside the Router's guard
  // pipeline, which aborts the navigation and strands the user on the page.
  // Defaulting to `true` keeps a component that has no opinion from blocking exits.
  if (typeof component?.canDeactivate !== 'function') return true;

  return component.canDeactivate(destination);
};
